import { render, staticRenderFns } from "./TitleDetailSideInfos.vue?vue&type=template&id=31684c0c&scoped=true"
import script from "./TitleDetailSideInfos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailSideInfos.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailSideInfos.vue?vue&type=style&index=0&id=31684c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31684c0c",
  null
  
)

export default component.exports